import * as React from 'react';

import {  ConnectedAddUserPanel } from './panels/AddUserPanel';
import { ConnectDataPanel } from './panels/ConnectDataPanel';
import { GettingStartedPanel } from './panels/GettingStartedPanel';

import { DeprecatedEventWrapper } from '../../../common/analyticsEvents/DeprecatedEventWrapper';
import { IReactTranslateService } from '../../../common/react/IReactTranslateService';

import { ContentActions } from '../../../ts/services/ContentActions';
import { ServerService } from '../../../ts/services/ServerService';
import { WindowLocationService } from '../../../ts/services/WindowLocationService';

export class GuidePanelFactory {

  // Common Services
  private analyticsEvents: DeprecatedEventWrapper;
  private translate: IReactTranslateService;

  // GettingStartedPanel Services
  private ServerService: ServerService;
  private WindowLocationService: WindowLocationService;

  // ConnectToData Services
  private ContentActions: ContentActions;

  constructor(analyticsEvents: DeprecatedEventWrapper,
              translate: IReactTranslateService,
              ServerService: ServerService,
              WindowLocationService: WindowLocationService,
              ContentActions: ContentActions)
  {
    this.translate = translate;
    this.ServerService = ServerService;
    this.WindowLocationService = WindowLocationService;
    this.analyticsEvents = analyticsEvents;
    this.ContentActions = ContentActions;
  }

  // TODO: 1. Use a user's role to determine which panels to return
  //       2. Integrate Launch Control to allow different versions of panels.
  public getPanels(closeModalFn: () => void): any[] {
    return [
      <GettingStartedPanel
        analyticsEvents={this.analyticsEvents }
        ServerService={ this.ServerService }
        WindowLocationService={ this.WindowLocationService }
        translate={ this.translate }
      />,
      <ConnectedAddUserPanel
        analyticsEvents={this.analyticsEvents }
        translate={ this.translate }
        closeModalFn={ closeModalFn }
      />,
      <ConnectDataPanel
        translate={ this.translate }
        ContentActions={ this.ContentActions }
        analyticsEvents={this.analyticsEvents }
        ServerService={ this.ServerService }
      />
    ];
  }
}
